import React, { ElementType, FormHTMLAttributes } from 'react';
import Modal from './index';

type FormModalProps = {
    show: boolean;
    onHide: () => void;
    title: string;
    onSubmit: FormHTMLAttributes<HTMLFormElement>['onSubmit'];
    children: React.ReactNode;
    footer?: React.ReactNode;
    dialogClassName?: string;
    as?: ElementType;
};

const FormModal = ({
    show,
    onHide,
    title,
    onSubmit,
    children,
    footer,
    dialogClassName = 'mx-auto w-full max-w-2xl',
    as,
}: FormModalProps) => {
    return (
        <Modal show={show} onHide={onHide} dialogClassName={dialogClassName} as={as}>
            <form onSubmit={onSubmit} className="flex min-h-0 flex-1 flex-col rounded-lg bg-white shadow-xl dark:bg-zink-800">
                <Modal.Header className="shrink-0 border-b border-slate-200 px-6 py-4 dark:border-zink-600">
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="px-6 py-4">{children}</Modal.Body>
                {footer && (
                    <Modal.Footer className="flex justify-end gap-2 px-6 py-4 dark:border-zink-600">
                        {footer}
                    </Modal.Footer>
                )}
            </form>
        </Modal>
    );
};

export default FormModal;
